export const REACT_QUERY_KEYS = {
  YANDEX_MAP_ADDRESSES: 'yandex-map-addresses',
  PRIVACY_POLICY: 'privacy-policy',
  CURRENCY_LIST: 'currency-list',
  CATEGORY_DETAIL: 'category-detail',
  SIGN_UP_PARTNER_COUNT: 'sign-up-partner_count',
  SIGN_UP_PRODUCT_STEP: 'sign-product-step',
  SIGN_UP_SHOP_SETTINGS: 'sign-up-shop-settings',
  SHOP_DETAILS: 'shop-details',
  SHOP_COUNTRY_LIST: 'shop-country-list',
  SHOP_CATEGORY_LIST: 'shop-category-list',
  SHOP_DELIVERY_DETAILS: 'shop-delivery-details',
  SHOP_TELEGRAM_INFO: 'shop-telegram-info',
  SHOP_PICKUP_DETAILS: 'shop-pickup-details',
  COUNTRY_LIST: 'country-list',
  FARGO_CITY_LIST: 'fargo-city-list',
  COURIER_LIST: 'courier-list',
  UZPOST_CITY_LIST: 'uzpost-city-list',
  FARGO_DISTRICTS_LIST: 'fargo-districts-list',
  UZPOST_DISTRICTS_LIST: 'uzpost-districts-list',
  CITY_LIST: 'city-list',
  CITY_MERCHANT: 'city-merchant',
  SPOT_LIST: 'spot-list',
  CLOPOS_SPOT_LIST: 'clopos_spot-list',
  ALI_POS_SPOT_LIST: 'ali-pos-spot-list',
  SMART_UP_PRICE_TYPE_LIST: 'smart-up-price-type-list',
  CATEGORY: 'category',
  CATEGORY_SUB: 'category-sub',
  CATEGORY_LIST: 'category-list',
  CATEGORY_CATALOG_LIST: 'category-catalog-list',
  ADVERTISING_FEED_CATEGORY_LIST: 'advertising-feed-category-list',
  UNIT_LIST: 'unit-list',
  BRANCH_LIST: 'branch-list',
  PRICE_TYPE_REGOS: 'price-type-regos',
  WAREHOUSES_REGOS: 'warehouse-regos',
  BRANCH_ALL_LIST: 'branch-all-list',
  DELIVERY_MERCHANT: 'delivery-merchant',
  YES_POS: 'yes-pos',
  PRODUCT_STOCK: 'product-stock',
  BRANCHES_LIST: 'branches-list',
  BRANCH_DETAIL: 'branch-detail',
  SHOP_LIST: 'shop-list',
  GLOBAL_SETTINGS: 'global-settings',
  SHOP_LIST_ROW: 'shop-list-row',
  PRODUCT_LIST: 'product-list',
  REVIEW_LIST: 'review-list',
  PRODUCT_LIST_DISCOUNT: 'product-list-discount',
  PRODUCT_LIST_DISCOUNT_ONLINE_SHOP: 'product-list-discount-online-shop',
  MAILING_LIST: 'mailing-list',
  SMS_MAILING_LIST: 'sms-mailing-list',
  POST_CHANNELS: 'post-channels',
  TELEGRAM_PUBLICATIONS: 'telegram-publications',
  CATEGORIES_ONLINE_SHOP_LIST: 'categories-online-shop-list',
  SMS_MAILING_PAYMENT_HISTORY: 'sms-mailing-payment-history',
  MAILING_DETAIL: 'mailing-detail',
  SMS_MAILING_DETAIL: 'sms-mailing-detail',
  MAILING_USERS_LIST: 'mailing-users-list',
  SMS_MAILING_USERS_LIST: 'sms-mailing-users-list',
  PROMO_CODE_LIST: 'promo-code-list',
  SOURCE_LIST: 'source-list',
  PROMO_CODE_DETAIL: 'promo-code-detail',
  DISCOUNT_DETAIL_ONLINE_SHOP: 'discount-detail-online-shop',
  IKPU_LIST: 'ikpu-list',
  IKPU_TAX_LIST: 'ikpu-tax-list',
  IKPU_PACKAGE_LIST: 'ikpu-package-list',
  CUSTOMER_LIST: 'customer-list',
  CUSTOMER_ORDERS_LIST: 'customer-orders-list',
  IKPU_SETTINGS: 'ikpu-settings',
  STOCK_LIST: 'stock-list',
  STOCK_METRICS: 'stock-metrics',
  STOCK_HISTORY: 'stock-history',
  DISCOUNT_LIST: 'discount-list',
  DISCOUNT_LIST_ONLINE_SHOP: 'discount-list-online-shop',
  TELEGRAM_BOT_SETTINGS: 'telegram-bot-settings',
  PRODUCT_DETAIL: 'product-detail',
  BANNER_DETAIL: 'banner-detail',
  BOT_DETAIL: 'bot-detail',
  YANDEX_DETAIL: 'yandex-detail',
  WEBSITE_DETAIL: 'website-detail',
  CUSTOMER_DETAIL: 'customer-detail',
  CHAT_USERS_LIST: 'chat-users-list',
  CHAT_SETTINGS: 'chat-settings',
  CHAT_USER_MESSAGES_LIST: 'chat-user-messages-list',
  CHAT_USER_HEADER: 'chat-user-header',
  ORDER_STATUS_COUNT: 'order-status-count',
  ORDER_STATUS_LIST: 'order-status-list',
  ORDER_STATUS_DETAIL: 'order-status-detail',
  ORDER_AUTO_RESPONDER: 'order-auto-responder',
  PAYMENT_TYPE_LIST: 'payment-type-list',
  PAYMENT_LIST: 'payment-list',
  ACTIVE_PAYMENT_LIST: 'active-payment-list',
  PRE_DASHBOARD: 'pre-dashboard',
  DASHBOARD_CLIENTS_LIST: 'dashboard-clients-list',
  DASHBOARD_TOTALS: 'dashboard-totals',
  DASHBOARD_PLATFORMS: 'dashboard-platforms',
  DASHBOARD_TRAFFIC_SOURCE: 'dashboard-traffic-source',
  DASHBOARD_TOP_PRODUCTS: 'dashboard-top-products',
  DASHBOARD_MAP: 'dashboard-map',
  DASHBOARD_EARNING_GRAPH: 'dashboard-earning-graph',
  DASHBOARD_ORDER_STATUS: 'dashboard-order-status',
  PROFILE: 'profile',
  ME: 'me',
  ROLE_LIST: 'role-list',
  EMPLOYEE_LIST: 'employee-list',
  COURIER_ID_LIST: 'courier-id-list',
  BTS_REGIONS_LIST: 'bts-regions-list',
  BTS_POST_TYPES_LIST: 'bts-post-types-list',
  BTS_PACKAGES_LIST: 'bts-packages-list',
  BTS_DISTRCTS_LIST: 'bts-districts-list',
  ROLE_DETAIL: 'role-detail',
  ROLE_MENU_LIST: 'role-menu-list',
  ROBO_MARKET_LIST: 'robo-market-list',
  ROLE_EMPLOYEE_DETAIL: 'role-employee-detail',
  ROBO_MARKET_APP_LIST: 'robo-market-app-list',
  INSTAGRAM: 'instagram',
  ROBO_MARKET_SLIDER_LIST: 'robo-market-slider-list',
  ROBO_MARKET_APP_COMMENT: 'robo-market-app-comment',
  ROBO_MARKET_APP_DETAIL: 'robo-market-app-detail',
  BANNER_LIST: 'banner-list',
  BANNER_LIST_ONLINE_SHOP: 'banner-list-online-shop',
  CATEGORY_BANNER_LIST: 'category-banner-list',
  ORDER_CATEGORY_LIST: 'order-category-list',
  ORDER_PRODUCT_LIST: 'order-product-list',
  ORDER_PRODUCT_BY_ID: 'order-product-by-id',
  ORDER_FORM_DETAIL: 'order-form-detail',
  NOTIFICATION_LIST: 'notification-list',
  NOTIFICATION_COUNT: 'notification-count',
  PRICING_PLAN_PAYMENT_STATUS: 'pricing-plan-payment-status',
  BILLZ_TOKEN: 'billz-token',
  IIKO_TOKEN: 'iiko-token',
  IIKO_ORGANIZATIONS: 'iiko-organizations',
  BITO_ORGANIZATIONS: 'bito-organizations',
  BITO_PRICE_TYPE: 'bito-price-type',
  BITO_EMPLOYEES: 'bito-employees',
  POSTER_SOURCES: 'poster-sources',
  IIKO_TERMINALS: 'iiko-terminals',
  IIKO_SPOTS: 'iiko-spots',
  IIKO: 'iiko',
  ATMOS_CARDS: 'atmos-cards',
  QR_CODE: 'qr-code',
  PBX_DETAIL: 'pbx-detail',
  BTS_DETAIL: 'bts-detail',
  POSTER_DETAIL: 'poster-detail',
  CLOPOS_DETAIL: 'clopos-detail',
  REGOS_DETAIL: 'regos-detail',
  ALI_POS_DETAIL: 'ali-pos-detail',
  AMOCRM_DETAIL: 'amo-crm-detail',
  YANDEX_MARKET_DETAIL: 'yandex-market-detail',
  YANDEX_DELIVERY_DETAIL: 'yandex-delivery-detail',
  BITO_DETAIL: 'bito-detail',
  UZUM_MARKET_DETAIL: 'uzum-market-detail',
  NOOR_DELIVERY_DETAIL: 'noor-delivery-detail',
  SMART_UP_DETAIL: 'smart-up-detail',
  RKIPPER_DETAIL: 'rkipper-detail',
  UZPOST_DETAIL: 'uzpost-detail',
  CLICK_SUPER_APP_DETAIL: 'click-super-app-detail',
  FARGO_DETAIL: 'fargo-detail',
  INSTAGRAM_DETAIL: 'instagram-detail',
  MEASURES: 'measures',
  DIZGO_DETAIL: 'dizgo-detail',
  ERA_DETAIL: 'era-detail',
  ROBO_POCHTA_DETAIL: 'robo-pochta-detail',
  ERA_STORES_DETAIL: 'era-stores',
  CASHBACK_DETAIL: 'cashback-detail',
  WOLT_DETAIL: 'wolt-detail',
  ADMIN_TOKEN: 'admin-token',
}
